import Vue from "vue";
import Vuex from "vuex";

import loadData from "./loadData";
import profile from "./profile";
import quesioner from "./master/quesioner";
import question from "./master/question";
import vendor from "./master/vendor";
import ideation from "./ideation/ideation";
import rfi from "./ideation/rfi";
import gendtaGendis from "./master/genta_gendis"
import roleManagement from "./role_management/role"
import role from "./master/role"
import userData from "./master/user"
import file from "./ideation/file"

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		loadData,
		profile,
		quesioner,
		question,
		vendor,
		ideation,
		rfi,
		gendtaGendis,
		roleManagement,
		userData,
		role,
		file
	},
});
